module.exports = __webpack_public_path__ + "img/eventfeatured_list2.2a07a604.png";